import React from "react"

import {
  Adac,
  Agc,
  Amber,
  Arena2036,
  Bosch,
  Bridgestone,
  Bp,
  Ceat,
  Dpdhl,
  Dxc,
  Eberspaecher,
  Forvia,
  Gf,
  Hero,
  Huf,
  Hutchinson,
  Hyundai,
  Maxion,
  Mercedesbenz,
  Motherson,
  Novelis,
  Nxp,
  Plasticomnium,
  Pnp,
  Porsche,
  Schaeffler,
  Sekisui,
  St,
  Togg,
  Unistuttgart,
  Webasto,
  Zf,
} from "../defaults/assets/logos/partnerlogos/index"

const PartnerIcons = {
  recoh6womsMXzRcWN: Adac,
  recpG1OwkQlgh18sc: Agc,
  recyo8vCOxT2z1Slt: Amber,
  recMtBM1tBofztLUS: Arena2036,
  recjxDW9olo5tdCsB: Bosch,
  rec9mpn4fYJYR1XeW: Bp,
  reczyE1PVnPp80oYY: Bridgestone,
  recZZeP2zsQvF5pnf: Ceat,
  recFvN2UwC6bVUbkU: Dpdhl,
  recAMG6Mq0o6freyU: Dxc,
  recESoQ20nPYhoKx2: Eberspaecher,
  reccP2VAycH6jmPWB: Forvia,
  recuyNvAR4JBnTHcT: Gf,
  recfrXNTqjJKocI4H: Hero,
  recFvvY9RntEkTb92: Huf,
  recdH2GrkrjcOWxTy: Hutchinson,
  recss86PEsJbRgPHN: Hyundai,
  reclp1oexIW9DxQeg: Maxion,
  recnQJsCWPwrzeZbR: Mercedesbenz,
  rec6nDRaewGCU6Xv6: Motherson,
  reckk0fuab7pWVOWW: Novelis,
  rec9nHbY8Yi6b3CVo: Nxp,
  recKPHCPJ1g6UjGNc: Plasticomnium,
  reczAA2wMklPG1O0w: Pnp,
  recU6C6eQVJaGFssr: Porsche,
  recKjVMTDHC6WHZhE: Schaeffler,
  rec5vDmLu0xWli2m1: Sekisui,
  recM1YjmME7GAP3tb: St,
  recguqEvYtjL0xhrT: Togg,
  recv8PadffwUDOtPJ: Unistuttgart,
  recVieMESSMhgixcu: Webasto,
  recd69TP2PRB1OMlQ: Zf,
}

const PartnerLogo = ({ id, className }) => {
  let Icon = undefined

  if (PartnerIcons[id] !== undefined) {
    Icon = PartnerIcons[id]
  } else {
    Icon = Pnp
  }

  return <>{Icon ? <Icon className={className} /> : ""}</>
}

export default PartnerLogo
